<icc-list searchable="true" [items]="fabrics"  (select)="selectFabric($event)" [itemTemplate]="'itemColor'" [selected]="selectedFabricId"></icc-list>
